import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Application } from '../../firestore_model';
import { useInjection } from '../../../di_container/InjectionProvider';
import { Constants } from '../../../common/constants';
export const useApplyClinic = () => {
    const { container } = useInjection();
    const { t } = useTranslation();
    const { pagination } = Constants;
    // State
    const [loading, setLoading] = useState(false);
    const columns = [
        { id: 'applyDate', label: '申請日時', minWidth: 100 },
        { id: 'corporateName', label: '契約者名', minWidth: 120 },
        { id: 'facilityName', label: '施設名', minWidth: 120 },
        { id: 'facilityDiv', label: '施設区分', minWidth: 80 },
        { id: 'status', label: '状況', minWidth: 80 },
        { id: 'detailButton', label: '', minWidth: 80, align: 'right' },
    ];
    // UseCase
    const applyClinic = useCallback(async (clinic) => {
        if (loading)
            return;
        setLoading(true);
        try {
            const repository = container.resolve('ImoryApiRepository');
            await repository.applyClinic(clinic);
        }
        catch (e) {
            console.error('error', e);
            setLoading(false);
            throw e;
        }
        setLoading(false);
    }, []);
    const loadClinicApplicationList = useCallback(async (lastDocument) => {
        setLoading(true);
        try {
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path: Application.Clinic.collectionReference().path,
                isGroup: false,
                limit: pagination.limit,
                startAfter: lastDocument,
                orderBy: {
                    fieldPath: 'createdAt',
                    directionStr: 'desc',
                },
            });
            setLoading(false);
            return {
                data: result.docs.map((item) => Application.Clinic.fromSnapshot(item)),
                lastDocument: result.lastDocument,
            };
        }
        catch (e) {
            console.error('error', e);
            setLoading(false);
            throw e;
        }
    }, []);
    const executeUnapprovedClinic = useCallback(async (applyId) => {
        setLoading(true);
        try {
            const item = await Application.Clinic.get(applyId);
            if (item !== undefined) {
                if (item.isApproval === true) {
                    throw Error(t('承認済みの申し込みを未承認にすることはできません。'));
                }
                item.isApproval = false;
                await item.update();
            }
            setLoading(false);
        }
        catch (e) {
            console.error('error', e);
            setLoading(false);
            throw e;
        }
    }, []);
    const executeApprovedClinic = useCallback(async (applyId) => {
        setLoading(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            const result = await imoryApiRepository.approvalClinic(applyId);
            console.log('result', result);
            setLoading(false);
        }
        catch (e) {
            console.error('error', e);
            setLoading(false);
            throw e;
        }
    }, []);
    return {
        applyClinic,
        loadClinicApplicationList,
        executeUnapprovedClinic,
        executeApprovedClinic,
        loading,
        columns,
    };
};
